module.exports = [{
      plugin: require('/home/viciu/prog/deployedpl/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-41819992-1"],"head":true,"alwaysSendReferrer":true},
    },{
      plugin: require('/home/viciu/prog/deployedpl/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/home/viciu/prog/deployedpl/src/components/layout.js"},
    },{
      plugin: require('/home/viciu/prog/deployedpl/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
